window.getCurrentLang = function () {
  if (window.qtx && window.qtx.getActiveLanguage) return window.qtx.getActiveLanguage();

  var matches = window.location.href.match(/(\/(de|en|ja)\/)/gi);
  return matches && matches.length && matches[0];
};
